import { useEffect, useState, forwardRef } from "react";
import {
  IconButton,
  Button,
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Paper,
  Grid,
  Typography,
} from "@mui/material";

import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable.jsx";

import { errorSnackbar } from "../../../actions/snackbar.js";

// import { deleteMeeting } from "../../../api/meetings.js";
import { caseDocsTable } from "../../../config/grid-column-defs.js";
import { DeleteForever } from "@mui/icons-material";
import {
  deleteDocumentById,
  getCaseDocuments,
  getDocumentById,
} from "../../../api/documents.js";
import useCaseList from "../../../hooks/useCaseList.js";
import useSnackbar from "../../../hooks/useSnackbar.js";
import useErrorHandler from "../../../hooks/useErrorHandler.js";

// i don't know why the hell is user.token not working inside getFile()
// i am caching it here.
let authToken = "";

export default function CaseDocuments() {
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const dispatch = useDispatch();
  const errorHandler = useErrorHandler();

  const [loading, setLoading] = useState(true);

  const [deletingDocId, setDeletingDocId] = useState("");

  const [docTableRefreshCount, setDocTableRefreshCount] = useState(0);
  function refreshDocTable() {
    setDocTableRefreshCount((prev) => prev + 1);
  }

  const { selectedCaseName, setSelectedCaseId } = useCaseList();
  setSelectedCaseId(params.id);

  useEffect(() => {
    if (caseDocsTable.some((m) => m.field === "action")) return;
    caseDocsTable.unshift(
      {
        field: "action",
        headerName: "Action",
        value: "DEL",
        maxWidth: 100,
        cellRenderer: () => (
          <IconButton size="small" variant="contained" color="error">
            <DeleteForever />
          </IconButton>
        ),
      },
      {
        headerName: "Filename",
        field: "name",
        cellRenderer: (params) => (
          <span style={{ cursor: "pointer" }}>{params.value}</span>
        ),
        onCellClicked: getFile,
      }
    );
  }, [caseDocsTable]);

  async function getFile({ data }) {
    try {
      setLoading(true);
      const blob = await getDocumentById(authToken, data.id);
      const file = window.URL.createObjectURL(blob.data);
      window.open(file, "_blank");
    } catch (error) {
      dispatch(errorSnackbar("Error in Fetching File"));
    } finally {
      setLoading(false);
    }
  }

  function onDocTableCellClicked({ colDef, data }) {
    if (colDef.field === "action") {
      setDeletingDocId(data.id);
    }
  }

  async function getDocTableData(limit, offset) {
    try {
      authToken = user.token;
      const { data } = await getCaseDocuments(user.token, params.id, {
        limit,
        offset,
      });
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      errorHandler(error);
      console.log(error);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  const onDeleteComplete = () => {
    refreshDocTable();
    setDeletingDocId("");
  };

  return (
    <>
      <Paper className="odr-card">
        <Box
          display="flex"
          justifyContent="space-between"
          className="odr-card-header"
        >
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Grid item xs={12} sm={6} md={9} lg={9}>
              <Typography className="heading-title">
                Case: <b>{selectedCaseName}</b>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Link to={`/documents/${params.id}/new`}>
                <Button
                  variant="contained"
                  size="large"
                  color="primary"
                  className="blue-button"
                  fullWidth
                >
                  Add Documents
                </Button>
              </Link>
            </Grid>
          </Grid>
          {loading ? <CircularProgress /> : <></>}
        </Box>
        <div className="odr-main-table">
          <AgGridPaginatedTable
            getTableRows={getDocTableData}
            onCellClicked={onDocTableCellClicked}
            columns={caseDocsTable}
            perPage={10}
            refreshCounter={docTableRefreshCount}
          />
        </div>
        <DeleteMeetingDialog
          deletingDocId={deletingDocId}
          setOpen={setDeletingDocId}
          onDeleteComplete={onDeleteComplete}
          token={user.token}
        />
      </Paper>
    </>
  );
}

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DeleteMeetingDialog({
  setOpen,
  deletingDocId,
  onDeleteComplete,
  token,
}) {
  const { data: user } = useSelector((state) => state.user);
  const snackbar = useSnackbar();
  const handleClose = () => {
    setOpen("");
  };
  const errorHandler = useErrorHandler();

  const handleDelete = async () => {
    try {
      await deleteDocumentById(token, deletingDocId);
      snackbar.showSuccess("Meeting Deleted");
      onDeleteComplete();
    } catch (error) {
      errorHandler(error);
      // snackbar.showError();
      setOpen("");
    }
  };

  return (
    <Dialog
      open={Boolean(deletingDocId)}
      TransitionComponent={Transition}
      keepMounted
      //onClose={handleClose}
      onClose={() => {       
      }}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle className="heading-title">Delete Meeting</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          The meeting will be deleted forever.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          size="large"
          variant="outlined"
          color="secondary"
          onClick={handleClose}
          className="black-border-button"
        >
          Cancel
        </Button>

        <Button
          size="large"
          variant="text"
          color="error"
          className="red-boder-button"
          disabled={/^trial_user$/i.test(user.roles) ? true : false}
          onClick={handleDelete}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
